import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://ysepabjarpcosxwclkyc.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlzZXBhYmphcnBjb3N4d2Nsa3ljIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA1MzUzMDksImV4cCI6MjA3NjExMTMwOX0.8d0KJX17ZcbI1rb8P71IzzwN0FoTrRzTev8QzSA9WRM";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
